import GLightbox from "glightbox";

GLightbox({
    touchNavigation: true,
    width: "100%",
    height: "100%",
    type: "image",
});
